import type * as d3 from 'd3'

import type { ChartScales } from '@/features/bidding/types/bidLadder'

export function renderMarketLabels(
  g: d3.Selection<SVGGElement, unknown, null, undefined>,
  scales: ChartScales,
  hasUpMarket: boolean,
  hasDownMarket: boolean,
) {
  const { xScale } = scales
  const centerX = xScale(0)

  // Position labels directly at zero line, near top of chart
  if (hasDownMarket) {
    g.append('text')
      .attr('x', centerX - 8)
      .attr('y', -10)
      .attr('text-anchor', 'end')
      .attr('font-size', '11px')
      .attr('font-weight', 400)
      .attr('fill', '#6b7280')
      .style('letter-spacing', '0.03em')
      .text('DOWN')
  }

  if (hasUpMarket) {
    g.append('text')
      .attr('x', centerX + 8)
      .attr('y', -10)
      .attr('text-anchor', 'start')
      .attr('font-size', '11px')
      .attr('font-weight', 400)
      .attr('fill', '#6b7280')
      .style('letter-spacing', '0.03em')
      .text('UP')
  }
}
